"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var CartPage = /*#__PURE__*/function (_window$AbstractView) {
    _inherits(CartPage, _window$AbstractView);

    var _super = _createSuper(CartPage);

    _createClass(CartPage, null, [{
      key: "CART_CHANGE_SUCCESS",
      get: function get() {
        return "cart_add_success";
      }
    }, {
      key: "CART_CHANGE_ERROR",
      get: function get() {
        return "cart_add_error";
      }
    }]);

    function CartPage(id, options) {
      var _this;

      _classCallCheck(this, CartPage);

      _this = _super.call(this, id, options);
      _this.$priceTextMoney = _this.$domElement.find(".price-text");
      return _this;
    }

    _createClass(CartPage, [{
      key: "init",
      value: function init() {
        var _this2 = this;

        this.$domElement.find(".cart-card").each(function (i, el) {
          _get(_getPrototypeOf(CartPage.prototype), "addModules", _this2).call(_this2, new window.CartCard(_this2.id + "_cart-card_" + i, {
            $domElement: $(el)
          }));
        });

        _get(_getPrototypeOf(CartPage.prototype), "init", this).call(this);
        /**
         *  Observer for new modules add / old modules remove
         */


        this.$domElement.on(AbstractView.EL_AUTO_INSTANCE_MUTATION, function (event, type, el) {
          if (type == "removed") {
            $(".cart-content .col-12").filter(function (index) {
              return this.children.length === 0;
            }).remove();
          }
        });
        this.setAutoInstance([{
          selector: ".cart-card",
          ModuleClass: window.CartCard,
          observeChild: ".cart-content",
          // if null it takes the domElement of the view
          subtree: true,
          options: {}
        }]);
        this.$domElement.find("#cart-page__cart-js-submit-btn").on("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          Globals.checkoutQuantityLiveUpdate();
          Globals.pushBeginCheckoutDataLayer();
        });
        this.pushViewCartDataLayer();
      }
    }, {
      key: "update",
      value: function update(response) {
        this.$priceTextMoney.html(slate.Currency.formatMoney(response.total_price, Globals.moneyFormat));
        this.$domElement.find(".cart-page")[response.items.length ? "removeClass" : "addClass"]("no-results");
      }
    }, {
      key: "pushViewCartDataLayer",
      value: function pushViewCartDataLayer() {
        console.log('-----> pushViewCartDataLayer');
        this.AJAXrequest = $.ajax({
          dataType: "json",
          url: "/cart.js",
          success: function success(data) {
            // console.log('cart data', data);
            var products = [];

            for (var k = 0, len = data.items.length; k < len; k++) {
              var inventory_quantity = data.items[k].quantity;
              var temp_pr = {
                item_id: data.items[k].product_id.toString(),
                item_name: data.items[k].product_title,
                currency: Shopify.currency.active,
                item_brand: data.items[k].vendor,
                item_category: "Apparel",
                item_category2: data.items[k].variant_options[1],
                item_category3: undefined,
                item_category4: undefined,
                price: Number(slate.Currency.formatMoney(data.items[k].price, Globals.moneyFormat).toString().replace('€', '').replace('.', '').replace(',', '.')),
                available_quantity: inventory_quantity,
                quantity: 1,
                item_variant: data.items[k].variant_id.toString()
              };
              products.push(temp_pr);
            }
            /* console.log('dataLayerPush', {
            	event: "view_cart",
            	ecommerce: {
            		items: products
            	}
            }); */


            dataLayer.push({
              ecommerce: null
            });
            dataLayer.push({
              event: "view_cart",
              ecommerce: {
                items: products
              }
            });
            Globals.CART_ITEMS = products;
          },
          error: function error(err) {
            console.log(err);
          }
        });
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.$domElement.find("#cart-page__cart-js-submit-btn").off("click");

        _get(_getPrototypeOf(CartPage.prototype), "dispose", this).call(this);
      }
    }]);

    return CartPage;
  }(window.AbstractView);

  window.CartPage = CartPage;
})(window);
